export const API_PATH_ApiDeviceMgmtDevicesGet = '/services/devices-mgtm/apiDeviceMgmtDevicesGet';
